import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "../../../components/Grid/GridItem.jsx";
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import Button from "../../../components/CustomButtons/Button";
import Snackbar from "../../../components/Snackbar/Snackbar";
// @material-ui/core icons
import NotificationErrorIcon from "@material-ui/icons/Error";
import NotificationFailedIcon from "@material-ui/icons/Cancel";
import NotificationSuccessIcon from "@material-ui/icons/DoneAll";
import Select from "../../../components/CustomSelect/CustomSelect";
import makeAnimated from "react-select/animated";
// Models & service
import {getAssetsAvailable} from "../../../services/assetService";
// Styles
import formStyle from "../../../assets/jss/custom-components/formStyle";
import {NOTIFICATION_DURATION} from "../../../variables/coreConstants";
import {
    disableComponent, enableComponent,
    getData, isSuccessfulCreate,
    selectValidation,
} from "../../../utils/helpersFunctions";
import {assign} from "../../../services/statusService";
import {BASE_URL_CORE, ZONE_ASSET_ASSIGN} from "../../../variables/apiConstants";
import {primaryColor} from "../../../assets/jss/material-dashboard-react";
import {validateSession} from "../../../services/api";
import {withRouter} from "react-router-dom";
import {withTranslation} from "react-i18next";


const animatedComponents = makeAnimated();


class AssetZoneAssignmentForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            asset: '',
            assetsOptions: [],
            loadingAssets: true,
            notificationMessage: '',
            notification: false,
            color: 'success',
            icon: NotificationSuccessIcon,
            disableField: false,
        };
        this.assignAsset = this.assignAsset.bind(this);
        this.cleanData = this.cleanData.bind(this);
    }

    componentDidMount() {
        this.request();
    }

    changeAssetSelect = asset => {
        this.setState({ asset });
    };

    cleanData() {
        this.setState({
            asset: '',
        });
    }

    showNotification = (msj, color, icon, refresh) => {
        this.setState({
            notificationMessage: msj,
            color: color,
            icon: icon,
            notification: true,
        });

        window.setTimeout(
            function() {
                this.setState({ notification: false });

                if (refresh != null)
                    this.props.closeForm("openAsset", false, refresh);

            }.bind(this),
            NOTIFICATION_DURATION
        );
    };

    hideNotification = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ notification: false });
    };


    request() {
        const { t } = this.props;
        let assetsValues;

        getAssetsAvailable()
            .then((res) => {
                assetsValues = res.data.map( item => {
                    return { value: item.id , label: item.name };
                });
                this.setState({ loadingAssets: false} );
                this.setState({ assetsOptions: assetsValues});
            })

            .catch((err) => {
                this.setState({ loadingAssets: false} );
                if (err.response) {
                    this.showNotification(t('GET_ASSETS_ERROR'), "danger", NotificationFailedIcon, null);
                    validateSession(err.response, this.props.history);
                }
            });
    }


    assignAsset() {
        const { t } = this.props;

        if (selectValidation(this.state.asset)) {
            this.showNotification(t('ASSETS_REQUIRED'), "danger", NotificationErrorIcon, null);

        } else {
            let zone = getData("zone");
            let assetsId = this.state.asset.map( item => {
                return { id: item.value };
            });

            let dataParameters = {
                "zone_id": zone.id,
                "assets": JSON.stringify(assetsId)
            };

            disableComponent(this, "disableField");
            assign(BASE_URL_CORE, ZONE_ASSET_ASSIGN, dataParameters)
                .then((response) => {
                    if (isSuccessfulCreate(response)) {
                        this.showNotification(response.data.message, "primary", NotificationSuccessIcon, true);
                    } else {
                        enableComponent(this, "disableField");
                        this.showNotification(response.data.message, "danger", NotificationErrorIcon, null);
                    }
                })
                .catch(error => {
                    enableComponent(this, "disableField");
                    if (error.response) {
                        this.showNotification(error.response.data.message, "danger", NotificationFailedIcon, null);
                        validateSession(error.response);
                    }
                });
        }
    }


    render(){
        const { classes, t } = this.props;

        const AssignAssetButton = () => (
            <Button
                color="primary"
                className={classes.buttonSpacing}
                onClick={() => this.assignAsset()}
                disabled={this.state.disableField}
            >
                {t('BTN_ASSIGN')}
            </Button>
        );

        return (
            <div className={classes.formContainer}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.selectControlMax}>
                            <InputLabel htmlFor="asset" className={classes.selectTitle}>
                                {t('ASSETS_TEXT')}
                            </InputLabel>
                            <Select
                                value={this.state.asset}
                                onChange={this.changeAssetSelect}
                                components={animatedComponents}
                                options={this.state.assetsOptions}
                                placeholder={t('SELECT_TEXT')}
                                isMulti={true}
                                isClearable={true}
                                maxMenuHeight={100}
                                closeMenuOnSelect={false}
                                theme={theme => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary: primaryColor[0],
                                    },
                                })}
                            />
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.rightPaper}>
                            <Button
                                color="white"
                                className={classes.buttonSpacing + " " + classes.cancelButton}
                                onClick={() => this.props.closeForm("openAsset", false, false)}
                            >
                                {t('BTN_CANCEL')}
                            </Button>
                            <AssignAssetButton/>
                        </div>
                    </GridItem>
                    <Snackbar
                        place="tc"
                        color={this.state.color}
                        icon={this.state.icon}
                        message={this.state.notificationMessage}
                        open={this.state.notification}
                        closeNotification={this.hideNotification}
                        close
                    />
                </GridContainer>
            </div>
        );
    }
}

AssetZoneAssignmentForm.propTypes = {
    classes: PropTypes.object
};

export default withRouter(withStyles(formStyle)(withTranslation()(AssetZoneAssignmentForm)));